import React from 'react';
import { Box } from '@chakra-ui/react';
import BubbleTail from '@components/atoms/BubbleTail';
import { motion } from 'framer-motion';

const TextNode = ({
  data,
  isVisible = false,
  index,
  itemAnim,
  onAnimationStarted = () => {},
  onAnimationComplete = () => {}
}) => {
  return (
    <Box
      as={motion.div}
      initial="shellInitial"
      variants={itemAnim}
      custom={index}
      animate={isVisible ? `shellAnimate` : ``}
      onAnimationStart={() => onAnimationStarted()}
      onAnimationComplete={() => onAnimationComplete(index)}
      pos="relative"
      maxW="18.5rem">
      <Box
        as={motion.div}
        initial="nodeInitial"
        variants={itemAnim}
        animate="nodeAnimate"
        pos="relative"
        mb="1rem"
        w="fit-content"
        p="0.75rem 1rem"
        bg="purple.400"
        fontWeight="600"
        color="white">
        {data.text}
        <BubbleTail bgColour="#7D55C7" bottom="5px" left="-7px" />
      </Box>
    </Box>
  );
};

export default TextNode;
